import React from 'react';
import { Instagram, Mail, MapPin, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_upcycled-wellness/artifacts/rv2oybj3_585bf8ac-0deb-49c3-af7b-11d9240feef9.JPG";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo-wrapper">
              <img src={LOGO_URL} alt="Sole to Soul" className="footer-logo" />
            </div>
            <p className="footer-tagline">
              Sustainably Scented Wellness. Mindful Gifts.
            </p>
            <div className="footer-social">
              <a 
                href="https://www.instagram.com/soletosoul_27" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#products">Products</a></li>
              <li><a href="#why-us">Why Us</a></li>
              <li><a href="#uses">Uses</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Sustainability</h4>
            <ul className="footer-links">
              <li>♻️ Upcycled Fabrics</li>
              <li>🌱 Natural Essential Oils</li>
              <li>🌍 Zero Waste Initiative</li>
              <li>🇮🇳 Handmade in India</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <Instagram size={16} />
                <a href="https://www.instagram.com/soletosoul_27" target="_blank" rel="noopener noreferrer">
                  @soletosoul_27
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Sole to Soul. All rights reserved.
          </p>
          <p className="footer-made">
            Made with ❤️ for a sustainable future
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;